// extracted by mini-css-extract-plugin
export default {"container":"styles_container__ZB2dp","sourcesContainer":"styles_sourcesContainer__m1yGQ","skipButton":"styles_skipButton__CpheU"};